import * as React from 'react';
import { SVGProps } from 'react';

const SvgCar = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.92 6.01 21 12v8c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1H6v1c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-8l2.08-5.99C5.29 5.42 5.84 5 6.5 5h11c.66 0 1.22.42 1.42 1.01zM6.85 7l-1.08 3.11h12.45L17.14 7H6.85zM5 17h14v-5H5v5zm4-2.5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9 14.5zm7.5 1.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16.5 16z" />
  </svg>
);

export default SvgCar;
